import {
  ICreateNodeRequest,
  IMoveNodesRequest,
  IUpdateNodeRequest,
  IDeleteNodeRequest,
  ISplitNodeRequest,
} from '@/editor/api/services/types/requests';
import { INode, ICreateImage, IStoredImage } from '@/editor/types';
import {
  createNodeMutation,
  moveNodesMutation,
  updateNodeMutation,
  deleteNodeMutation,
  uploadImageMutation,
  splitNodeMutation,
} from '@/editor/api/graphql/editor-block.mutations';
import { apolloClient } from '@/apollo';

export class EditorBlockService {
  static async createNode(payload: ICreateNodeRequest): Promise<INode> {
    const {
      data: { newNode },
    } = await apolloClient.mutate({
      mutation: createNodeMutation,
      variables: payload,
    });
    return newNode;
  }

  static async moveNodes(payload: IMoveNodesRequest): Promise<boolean> {
    const result = await apolloClient.mutate({
      mutation: moveNodesMutation,
      variables: payload,
    });
    return !!result;
  }

  static async updateNode(payload: IUpdateNodeRequest): Promise<INode> {
    const {
      data: { updatedNode },
    } = await apolloClient.mutate({
      mutation: updateNodeMutation,
      variables: payload,
    });
    return updatedNode;
  }

  static async splitNode(payload: ISplitNodeRequest): Promise<boolean> {
    const result = await apolloClient.mutate({
      mutation: splitNodeMutation,
      variables: payload,
    });
    return !!result;
  }

  static async deleteNode(payload: IDeleteNodeRequest): Promise<INode> {
    const {
      data: { deletedNode },
    } = await apolloClient.mutate({
      mutation: deleteNodeMutation,
      variables: payload,
    });
    return deletedNode;
  }

  static async createImage({ name, url, type, file }: ICreateImage): Promise<IStoredImage> {
    const { data } = await apolloClient.mutate({
      mutation: uploadImageMutation,
      variables: {
        name,
        url,
        type,
        file,
      },
    });
    return data.createImage;
  }
}
